import { useTranslation } from "react-i18next";

const cards = [
  { key: "finds", icon: "ri-layout-grid-line", title: "cards.findsTitle", desc: "cards.findsDesc" },
  { key: "qc", icon: "ri-search-eye-line", title: "cards.qcTitle", desc: "cards.qcDesc" },
  { key: "shipping", icon: "ri-ship-line", title: "cards.shippingTitle", desc: "cards.shippingDesc" },
  { key: "buying", icon: "ri-book-open-line", title: "cards.buyingTitle", desc: "cards.buyingDesc" },
];

export default function ValueCards() {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {cards.map((card) => (
          <div
            key={card.key}
            className="rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300 transition-colors group"
          >
            <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
              <i className={`${card.icon} text-xl`}></i>
            </span>
            <h3 className="font-heading font-semibold text-base text-foreground-950 mt-4">{t(card.title)}</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mt-2">{t(card.desc)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}